<template>
  <section>
    <b-tag :type="colorStatus" rounded>{{ status }}</b-tag>
  </section>
</template>

<script>
export default {
  props: {
    status: {
      required: true,
      type: String
    }
  },
  data () {
    return {}
  },
  computed: {
    colorStatus () {
      switch (this.status) {
        case 'En proceso':
          return 'is-danger'
        case 'Pendiente':
          return 'is-warning'
        case 'Terminado':
          return 'is-success'
        default:
          return ''
      }
    }
  }
}
</script>
